export function initializeKendoLicense() {
    // Get license key from environment variables or configuration
    const licenseKey = process.env.VUE_APP_KENDO_LICENSE_KEY;

    // Set up a function to initialize license when Kendo is available
    const setLicense = () => {
        if (window.kendo) {
            // According to docs, this is the correct way to set license
            window.kendo.licenseKeys = {
                "kendo-ui-core": licenseKey,
                "kendo-ui-professional": licenseKey,
                // You can add specific components if needed
                "spreadsheet": licenseKey
            };
            return true;
        }
        return false;
    };

    // Try to set license immediately if Kendo is already loaded
    if (!setLicense()) {
        // If Kendo isn't loaded yet, set up a global function that can be called later
        window.kendoLicenseInitializer = setLicense;
    }
}
